import { UserResources } from '@leroy-merlin-br/backpack-services'

import { requestStore } from 'utils/request-store'

import instance from './api'
import { API_ENDPOINTS } from './constants'

export const getUserResources = async () => {
  const response = await instance
    .get<UserResources>(API_ENDPOINTS.userResources)
    .then(({ data }) => data)
    .catch((err) => {
      throw err
    })

  return response
}

export const storedGetUserResources = requestStore(getUserResources)
